import { ReactNode } from 'react'
import { Box, CircularProgress, Divider, Drawer, IconButton, Typography } from '@mui/material'
import { IconX } from '@tabler/icons-react'

interface CustomDrawerProps {
	opened: boolean
	onClose: () => void
	title?: ReactNode
	children: ReactNode
	footer?: ReactNode
	loading?: boolean
	width?: number | string
}

function CustomDrawer({
	opened,
	onClose,
	title,
	children,
	footer,
	loading = false,
	width = 460,
}: CustomDrawerProps) {
	return (
		<Drawer
			anchor="right"
			open={opened}
			onClose={onClose}
			PaperProps={{
				sx: {
					width,
					maxWidth: '100vw',
					display: 'flex',
					flexDirection: 'column',
					'@media (max-width: 1024px)': {
						width: '100%',
					},
				},
			}}
		>
			<Box sx={{ padding: '14px 18px', display: 'flex', alignItems: 'center', gap: 8 }}>
				<Typography sx={{ fontSize: 18, fontWeight: 700, flex: 1 }}>{title}</Typography>
				<IconButton
					onClick={onClose}
					aria-label="close drawer"
					sx={{
						minWidth: 44,
						minHeight: 44,
					}}
				>
					<IconX size={20} />
				</IconButton>
			</Box>
			<Divider />

			<Box sx={{ position: 'relative', flex: 1, overflowY: 'auto' }}>
				{loading && (
					<Box
						sx={{
							position: 'absolute',
							inset: 0,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							background: 'rgba(255, 255, 255, 0.7)',
							zIndex: 2,
						}}
					>
						<CircularProgress size={28} />
					</Box>
				)}
				<Box sx={{ padding: 0 }}>{children}</Box>
			</Box>

			{footer && (
				<>
					<Divider />
					<Box sx={{ padding: 5 }}>{footer}</Box>
				</>
			)}
		</Drawer>
	)
}

export default CustomDrawer
